import React from 'react'
import ListItem from './ListItem'
import PropTypes from 'prop-types'

const List = props => {
  if (props.list.length) {
    return props.list.map((listItem) => {
      return <ListItem key={listItem.id} activeItem={props.activeItem.toString() === listItem.id.toString()} listItem={listItem} handleItemClick={props.handleItemClick} level={props.level} />
    })
  } else {
    return null
  }
}

List.propTypes = {
  level: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
}

export default List
